import { render, staticRenderFns } from "./CosignersStep.vue?vue&type=template&id=793d7e5a&scoped=true&"
import script from "./CosignersStep.vue?vue&type=script&lang=js&"
export * from "./CosignersStep.vue?vue&type=script&lang=js&"
import style0 from "./CosignersStep.vue?vue&type=style&index=0&id=793d7e5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793d7e5a",
  null
  
)

export default component.exports